import React from "react";

import cls from './Label.module.scss';

const Label = ({ title, required, children }) => (
  <>
    <label className={cls.wrapper}>
      {required && <span className={cls.star}>*</span>}
      {!!title && <span className={cls.title}>{title}</span>}
    </label>

    {!!children && children}
  </>
);

export default Label;